import { render } from "./AllOrderItems.vue?vue&type=template&id=6b89d80c"
import script from "./AllOrderItems.vue?vue&type=script&lang=js"
export * from "./AllOrderItems.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__